import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../context/PbxContext';

import { accessLocalStorage, getContatById, valuesAnalyze, changeViewForms, createPhone, updateContact, deletePhone, deleteContact, updatePhone, clickToCall } from '../../services';

import Loading from '../../components/Loading/LoadingModule';
import PhoneCard from './PhoneListShowCard';
import InputSetPhone from './PhoneCreate';
import InputEditPhone from './PhoneEdit';

import '../../libs/bulma.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faSave, faArrowLeft, faTrash } from '@fortawesome/free-solid-svg-icons';

function ShowContacts() {
  const getItensStateGlobal = useContext(PbxContext);
  const { setItemsSelectedToEdit, toggleIsHidden, toggleIsChangeFormElements, itemsSelectedToEdit, } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [ph, setPh] = useState([]);
  const [disable, setDisable] = useState(true);
  const [phoneModify, setPhoneModify] = useState({});
  const [inputPhone, setInputPhone] = useState({});
  const [idModPhone, setIidModPhone] = useState({});

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    // if (dataUser && role !== 'root') return history.push('/home');
    const contactFetch = await getContatById({ id: itemsSelectedToEdit });
    if(itemsSelectedToEdit.length <= 0) return history.push('/agenda/lista');
    if(contactFetch === undefined) setLoading(true);
    if(contactFetch['phones'].length > 0) setPh(contactFetch['phones']);
    setValues(contactFetch);
    return setLoading(false);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'cnpj' || name === 'numberphone' || name === 'editnumberphone') {
      let checkValueIsNumber = checkNumber(value);
      if(name === 'qtt' && value > 1000) checkValueIsNumber = false;
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    if(name === 'company' || name === 'addr') {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value )
    if(Object.keys(validate).length >= 5) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const insertNumberPhone = () => {
    changeVisibityMessages(true, 'buttons-edit-contact');
    changeVisibityMessages(true, 'list-phones');
    changeVisibityMessages(false, 'input-phone');
  };

  const handleChangeInput = (item) => {
    const { name, value } = item;
    const itemStatus = handleChangeDataAnalyze(name, value);
    setInputPhone({ number: Number(value), contactid: values['idcont'] })
  };

  const handleChangeInputPhoneEdit = (item, idPhone) => {
    const { name, value } = item;
    const itemStatus = handleChangeDataAnalyze(name, value);
    setPhoneModify({ phone: Number(value), id: idModPhone })
  };

  const saveNewPhone = async () => {
    try {
      const newPhone = await createPhone(inputPhone);
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
  
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-phone');
      document.getElementById('numberphone').value='';
      setInputPhone({})
    } catch (error) {
      console.log(error)
    }
  };

  const cancelCreatePhone = async () => {
    try {
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-phone');
      document.getElementById('numberphone').value='';
      setInputPhone({})
    } catch (error) {
      console.log(error)
    }
  };

  const saveEditedPhone = async () => {
    const newPhone = await updatePhone(phoneModify);
    setItemsSelectedToEdit(phoneModify);
    await validateUserLogged();

    changeVisibityMessages(false, 'buttons-edit-contact');
    changeVisibityMessages(false, 'list-phones');
    changeVisibityMessages(true, 'input-edit-phone');
  };

  const cancelEditedPhone = async () => {
    try {
      changeVisibityMessages(false, 'buttons-edit-contact');
      changeVisibityMessages(false, 'list-phones');
      changeVisibityMessages(true, 'input-edit-phone');
    } catch (error) {
      console.log(error)
    }
  };

  const handleClickDelete = async () => {
    try {
      const sendDeleteContact = await deleteContact({ id: values['idcont'] });
      toggleIsHidden('#update-form');
      // toggleIsHidden('#buttons-edit-contact');
      toggleIsHidden('#alert-confirm-contact-delete');
      toggleIsHidden('#success-deleted-contacts');
      toggleIsHidden('#list-phones');
      setTimeout(() => {
        return history.push('/agenda/lista');
      }, 3000);
    } catch (error) {
      toggleIsHidden('#update-form');
      toggleIsHidden('#buttons-edit-contact');
      toggleIsHidden('#alert-confirm-contact-delete');
      toggleIsHidden('#error-delete-contact');
      toggleIsHidden('#list-phones');
      setTimeout(() => {
        return history.push('/home');
      }, 3000);
    }
  };

  const handleClickDeletePhone = async (data) => {
    const { value, phone } = data;
    try {
      const sendDeleteContact = await deletePhone({ id: Number(value) });
      if(values['phones'].length === 1) history.push('/agenda/lista');
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
    } catch (error) {
      changeVisibityMessages(false, `delete-phone-link-${value}`);
      changeVisibityMessages(true, `delete-phone-confirm-${value}`);
    }

  };
  
  const sendDataContactUpdate = async () => {
    const updateContactSend = await updateContact({
      id: values['idcont'],
      company: values['compname'],
      fantasy: values['namefantasy'],
      addr: values['addr'],
      cnpj: Number(values['cnpj']),
      email: values['mail'],
      alias: values['alias'],
      comment: values['comm'],
    });

    const result = Object.keys(updateContactSend).length > 0 ? true : false;
    if(result) {
      setLoading(false);
      setItemsSelectedToEdit([values['idcont']]);
      await validateUserLogged();
      changeVisibityMessages(false, 'success-updeted-contacts');
      setTimeout(() => {
        return changeVisibityMessages(true, 'success-updeted-contacts');
      }, 3000);
    };
    return;
  };

  
  const handleClickToCall = async (phone) => {
    let phoneFull = phone;
    if(phoneFull.length === 10 || phoneFull.length === 11) phoneFull = `0${phone}`;
    const { user } = await accessLocalStorage.getUserLocalStorage();
    const myEndpoint = { 
      name: `${values['namefantasy']}`,
      dest: phoneFull,
      exten: user.endpoint
    }
    console.log(myEndpoint);
    const result = await clickToCall(myEndpoint);
  };

  useEffect(() => {
    let cancel = false;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
          <div>
            <div className="columns">
              <div className="column is-half is-offset-one-quarter has-text-centered">
                <strong className="is-size-3">CONTATO</strong>
                <hr className="dropdown-divider"/>
              </div>
            </div>
            <div className="columns">
              <div className="column card is-half is-offset-one-quarter">
                <div className="card-content is-offset-one-quarter">
                  <div className="media">
                    <div className="media-left">
                    </div>
                    <div className="media-content">
                      <p className="subtitle is-6 has-text-grey is-family-code">Razão Social: <strong className="subtitle is-5 mr-4">{ values['compname'] } </strong> CNPJ/CPF: <strong className="subtitle is-5">{ values['cnpj'] }</strong></p>
                      <p className="subtitle is-6 has-text-grey is-family-code"> Nome Fantasia: <strong className="subtitle is-5">{ values['namefantasy'] }</strong></p>
                      <p className="subtitle is-6 has-text-grey is-family-code"> Endereço: <strong className="subtitle is-5">{ values['addr'] }</strong></p>
                      <p className="subtitle is-6 has-text-grey is-family-code">E-mail: <strong className="subtitle is-5 mr-4">{ values['mail'] } </strong> Alias: <strong className="subtitle is-5">{ values['alias'] }</strong></p>
                      <p className="subtitle is-6 has-text-grey is-family-code"> Comentarios: <strong className="subtitle is-5">{ values['comm'] }</strong></p>
                    </div>
                  </div>
                </div>
                <div id="list-phones" name="list-phones" className="columns py-2 is-multiline is-centered is-narrow has-text-centered">
                  { ph.map((phone) => <PhoneCard key={phone.phonenumber} phones={ phone } changeVisibityMessages={ changeVisibityMessages } handleClickToCall={ handleClickToCall } setPhoneModify={ setPhoneModify } setIidModPhone={ setIidModPhone } del={ handleClickDeletePhone }/>) }
                </div>
              </div>
            </div>
          </div>
      }
    </div>
  );
}

export default ShowContacts;
